import './src/styles/global.css';

export const onRouteUpdate = () => {};

export const onInitialClientRender = () => {};

export const wrapRootElement = ({ element }: { element: React.ReactNode }) =>
  element;
